/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {InputComponent} from '../input/input.component';
import {UntypedFormBuilder} from '@angular/forms';
import {NgbDropdown, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {Directive} from '@angular/core';

@Directive()
export abstract class InputDropdownBase extends InputComponent {

    protected readonly OPEN_ICON_CLASS = 'iwp-icon-gen_arrow_up';
    protected readonly CLOSED_ICON_CLASS = 'iwp-icon-gen_arrow_down';

    abstract dropdown: NgbTypeahead | NgbDropdown;

    constructor(protected formBuilder: UntypedFormBuilder) {
        super(formBuilder);
    }

    get dropdownButtonCypressTag(): string {
        return `${this.baseCypressTag}-dropdown-button`;
    }

    getDropdownButtonIconClass(dropdownIsOpen: boolean): string {
        return dropdownIsOpen ? this.OPEN_ICON_CLASS : this.CLOSED_ICON_CLASS;
    }
}
